import { getMaster } from "utils/api";

export const fetchStatisticsChange = async () => {
  return await getMaster("/stats/transactions?service=online");
};

export const fetchStatisticsCardType = async () => {
  return await getMaster("/stats/transactionsByCardType?service=online");
};
